






























































































































// @ts-nocheck
import merge from "lodash/merge";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DealListPageQuery } from "../../DealList/queries/_build_documents_list";
import { ServerResult } from "../../../core/http/server_result";

export const ITEMS_LIST = "ITEMS_LIST";

@Component
export default class ClientDealList extends Vue {
  @Prop() clientId!: string;
  @Prop() clientData!: any;

  tableParams = {};
  documents = [];
  loading = false;
  lastMeta = {};

  get defaultSort() {
    return [
      this.$route.query.sortField || "expected_delivery_date",
      this.$route.query.sortDirection || "desc",
    ];
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    // tableParams
    this.tableParams = merge(this.tableParams, {
      sortField: field,
      sortDirection: direction,
    });

    this.loadData();
  }

  private delayFilter: any = null;
  private delayFilterValue: any = null;

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.tableParams = merge(this.tableParams, {
          [this.delayFilter]: this.delayFilterValue,
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
    this.delayFilterValue = value;
    this.loadData();
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.tableParams = merge(this.tableParams, {
      page,
    });

    this.loadData();
  }

  loadData() {
    this.loading = true;

    (this as any)
      .$db([
        (this as any)
          .$q(ITEMS_LIST)
          .raw("documents.list")
          .action(
            DealListPageQuery.build(
              {
                ...this.tableParams,
                clientId: this.clientId,
              },
              {},
              true,
            ),
          ),
      ])
      .then((result: ServerResult) => {
        console.log(result.getOperation(ITEMS_LIST).getContent());
        const opResult = result.getOperation(ITEMS_LIST).getContent();

        this.documents = opResult.documents;
        this.lastMeta = opResult.meta;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.push({
      name: "deal-details",
      params: {
        id: row.id,
      },
    });
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}
